module.exports = __webpack_public_path__ + "img/coinbankB35.c56725ad.jpg";